"use client"

import { Gift } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GiftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GiftIcon = component(Icon)({ as: Gift })
